<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MEjsC1/tc-custom/9781250233585.jpg?1740716476660" alt="This image is the cover for the book Silent Squall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Squall
      </h1>
      <p class="bookDescription body article font2">
        <b>A poetic portrayal of the unseen tempests of emotional and physical abuse from the bestselling author of <i>Abandoned Breaths</i> and <i>I Needed a Viking</i>.</b><br/><br/>Raw and honest, the acclaimed author of <i>I Find You in the Darkness</i> shares her intensely personal, yet relatable stories through finely woven poetry. This new edition of <i>Silent Squall</i> includes an updated introduction and a brand-new chapter of modern poetry. Find understanding, comfort, and hope from the affecting poetry of <i>Silent Squall</i>.<br/><br/><i>I have singed wings,</i><br/><br/><i>and the edges of my heart</i><br/><br/><i>are charred, and crisp</i><br/><br/><i>by flames of your dismissal.</i><br/><br/><i>Yet even though I sift</i><br/><br/><i>through ashes of the past,</i><br/><br/><i>as I maneuver through</i><br/><br/><i>tomorrow . . . </i><br/><br/><i>my soul’s fingerprint</i><br/><br/><i>will be everlasting.</i><br/><br/>—Alfa
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alfa
      </h2>
      
      <p class="authorDescription body article">ALFA is a retired medical professional who has spent most of her career in Radiation Therapy. She credits her ability to express painful life experiences by studying the human body from the inside out. Unapologetic about her realistic take on heartache, she writes to let her readers know they are not alone in their pain. Alfa is the author of several books of poetry, including <I>I Find You in the Darkness, Amid Thirsty Vines, </I>and<I> Abandoned Breaths.</I> Follow her on Instagram.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e08cd2c